<template>
  <div class="container-fluid mb-6 mb-md-0">
    <router-view />
  </div>
</template>

<script>
export default {
	name: 'Referral',
};
</script>

<style scoped>
</style>
